module.exports = __webpack_public_path__ + "static/img/3.f8318fd5.png";